import { Capacitor } from '@capacitor/core';

export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0';

const DEVICE_KEY = 'sss.deviceId';

/** A persistent per-install id, sent as X-Device-Id (draft locks are per device). */
export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return 'no-storage';
  }
}

export type Platform = 'web' | 'ios' | 'android';

export function platform(): Platform {
  try {
    return Capacitor.getPlatform() as Platform;
  } catch {
    return 'web';
  }
}

export function isNative(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}
